/*
*  Legal pages - word for word from the original site. Don't reword these.
*  Blocks: { p }, { h2 }, { ul: [] }, { ol: [] }, { email } (a paragraph ending in the contact email)
*/

export const TERMS = {
  title: "Terms & Conditions",
  metaTitle: "Terms and Conditions",
  blocks: [
    { p: "By using this website, you agree to these terms. If you don’t agree, please do not use the website." },
    { h2: "What you can do:" },
    {
      ul: [
        "View pages on the website using a computer, mobile phone, or tablet.",
        "Print pages from the website.",
        "Watch videos and listen to audio uploaded on the site.",
      ],
    },
    { h2: "What you can’t do:" },
    {
      ol: [
        "Download materials for personal use.",
        "Edit or change any of the website’s content without permission.",
        "Reuse, republish, sell, rent, or use the website’s content for commercial purposes.",
        "Use the website in any illegal or harmful way.",
        "Use the information collected on the website for email marketing, SMS marketing, telemarketing, or direct mailing.",
      ],
    },
    { h2: "Copyright:" },
    { p: "All content on this website, including text, logos, images, videos, audio, and software, is owned by Janine Botha Attorneys Inc. and its authorized content providers." },
  ],
};

export const PRIVACY = {
  title: "Privacy Policy",
  metaTitle: "Privacy Policy",
  blocks: [
    { meta: ["Version 1", "Date: 4 March 2025"] },
    { p: "This Privacy Policy forms part of our Website terms of use. If you do not agree with any term of this Privacy Policy, you must cease your access of this Website immediately." },

    { h2: "1. Definitions" },
    { p: "The following words and phrases have these meanings in this document:" },
    {
      ul: [
        "“Personal Information” is as defined in POPI.",
        "“POPI” means the Protection of Personal Information Act 4 of 2013.",
        "“Process” in relation to Personal Information means to collect, organise, store, modify, retrieve, refer to, distribute, or erase, or otherwise as defined in POPI.",
        "“Us”, “we”, or “our” means Janine Botha Attorneys Inc. a company incorporated in terms of the company laws of the Republic of South Africa with registration number 2025/092636/21.",
        "“Website” means Internet website at URL www.jb-inc.co.za",
        "“You” or the “user” means any person who accesses this Website for any purpose.",
      ],
    },

    { h2: "2. Status and Amendments" },
    {
      ul: [
        "We respect and recognise the importance of protecting your privacy. This Privacy Policy statement sets out our information gathering and dissemination practices in respect of the Website.",
        "This Privacy Policy forms part of the Terms and Conditions of Use of this Website. If you do not agree with this Policy then you may not use this Website and are required to cease doing so immediately.",
        "We reserve the right to amend the terms and conditions of this Privacy Policy at any time without notice. It is your duty to be aware of the current version of this Privacy Policy. Please refer to the last revision number and date at the top of this document. Continued use of the Website subsequent to any amendments having been effected constitutes your acceptance of the Privacy Policy as amended.",
      ],
    },

    { h2: "3. Collection and Processing of Personal Information" },
    {
      ul: [
        {
          text: "Where you submit Personal Information via the Website the following principles are observed in the handling of that information:",
          sub: [
            "We will only collect Personal Information for a purpose consistent with the purpose for which it is required. The specific purpose for which information is collected will be apparent from the context in which it is requested.",
            "We will only process Personal Information in a manner that is adequate, relevant and not excessive in the context of the purpose for which it is processed.",
            "Personal Information will only be Processed for a purpose compatible with that for which it was collected, unless you have consented to an alternative purpose in writing or we are permitted by POPI or in terms of national legislation of general application.",
            "We will not disclose any Personal Information relating to you to any third party unless your prior written agreement is obtained or we are required to do so by law.",
            "We will destroy or delete any Personal Information that is no longer needed by us for the purpose it was initially collected, or subsequently Processed.",
            "You may, at any time, access your personal information which we hold. You may also correct your personal information held by us, should the need arise.",
          ],
        },
        "Note that, as permitted by POPI, we may use Personal Information collected to compile profiles for statistical purposes. No information contained in the profiles or statistics will be able to be linked to any specific user.",
        "We will use your Personal Information to provide you with customer service and in order to communicate with you regarding products or services from us which might be of interest for you. If you do not wish to receive marketing information, you may at any time contact us in response to a marketing or similar email from us and all such emails will contain instructions as to how to unsubscribe from such emails.",
      ],
    },

    { h2: "4. Collection of anonymous data" },
    {
      ul: [
        "We may use standard technology to collect information about the use of this Website. This technology is not able to identify individual users but simply allows us to collect statistics.",
        "We may utilise temporary or session cookies (a cookie is a small file that is placed on your hard drive) to keep track of users’ browsing habits. This allows us to track your use of this Website as well as your visits to other websites. Other websites may also use these cookies to track your browsing habits.",
        "Cookies by themselves will not be used to personally identify users but we may use them to compile de-identified statistics relating to use of services offered or to provide us with feedback on the performance of this Website.",
        {
          text: "The following classes of information may be collected in respect of users who have enabled cookies:",
          sub: [
            "The browser software used;",
            "IP address;",
            "Date and time of activities while visiting the Website;",
            "URLs of internal pages visited; and",
            "referring websites, search engines and the like.",
          ],
        },
        "If you do not wish cookies to be employed to customize your interaction with this Website it is possible to alter the manner in which your browser handles cookies. Please note that, if this is done, certain services on this Website may not be available.",
      ],
    },

    { h2: "5. Security" },
    {
      ul: [
        "We will take appropriate, reasonable technical and organisational measures as required by applicable law to protect the information submitted to or collected by this Website from loss, misuse, unauthorized disclosure, alteration or destruction.",
        "Should there be a security breach which compromises the user’s personal information, which we are reasonably expected to be aware of, we will attempt to make the user aware thereof.",
      ],
    },

    { h2: "6. Links to other Websites" },
    {
      ul: [
        "We have no control over and accept no responsibility for the privacy practices of any third party websites to which hyperlinks may have been provided and we strongly recommend that you review the privacy policy of any website you visit before using it further.",
      ],
    },

    { h2: "7. Queries" },
    { email: "If you have any queries about this Privacy Policy please contact us by emailing: " },
  ],
};
